module.exports = __webpack_public_path__ + "static/media/Road.5f771e03.jpg";